import React from 'react';
import { Button, Modal } from '@ss/mtd-react';

interface Props {
  visible: boolean;
  onClose: () => void;
}

const ConformModal: React.FC<Props> = ({ visible, onClose }) => {
  if (!visible) {
    return null;
  }

  return (
    <Modal
      title="个人信息使用确认书"
      onClose={onClose}
      style={{ width: '450px' }}
      className="footer__modal"
      getContainer={() => document.querySelector('.list') || document.body}
    >
      <Modal.Body>
        <div>
          <div className="modal__title">个人信息使用确认书</div>
          <div>
            <p>
              <div>鉴于：</div>
              <div>
                1.
                您将入职美团或为美团提供服务，公司可能会收集、使用您的个人信息；（公司是指北京三快在线科技有限公司及/或他美团旗下公司、关联主体，委托/授权的第三方）。
              </div>
              <div>
                2.
                公司重视个人信息和隐私的保护，也充分重视您的体验，会遵照个人信息保护、劳动相关法律法规（下称“适用法律”）收集、使用和保护您的个人信息和隐私。
              </div>
            </p>

            <p>
              <div>
                <span style={{ fontWeight: 'bold' }}>
                  请您务必在点击同意之前，审慎阅读、充分理解各条款内容，特别是涉及个人信息收集及处理相关条款、免除或者限制责任的条款、法律适用。
                </span>
                个人敏感信息、免除或者限制责任等重点条款，您应重点阅读。如您有任何疑问，请尽快联系我们。
              </div>
            </p>
            <p>
              <div>
                <span style={{ fontWeight: 'bold' }}>
                  当您点击确认同意，即表示您已充分阅读、理解且接受本文全部内容，并与公司达成一致，本文对您及公司均具有法律约束力。
                </span>
                公司亦可能结合内外部政策补充、调整相关内容，请您及时关注公司任何补充、调整，充分了解公司政策和对您的影响。
              </div>
            </p>

            <p>
              <div>
                <span style={{ fontWeight: 'bold' }}>1. 您同意向公司提供的个人信息范围</span>
              </div>
              <div>
                1.1
                个人基本信息：姓名、签名、证件、证件号码、国籍、户籍、户口、居住地址、民族、照片、社会保险号、公积金号、电话号码、电子邮件地址、工作经历、健康信息、家庭信息、紧急联系人信息等，以及在您应聘、入职、在职、服务过程中向公司提交的任何身份信息、个人特征、身体特征和任何对上述信息的更新；
              </div>
              <div>
                1.2
                工作信息：工作履历、公司、部门、职位职务职级、工作地点、入职和离职日期、合同状态、有效日期、离职原因、竞业义务、教育状况等；
              </div>
              <div>1.3 财务信息：银行账户信息（包括账号、开户行信息）、过往薪资数据、福利待遇、股票期权等；</div>
              <div>1.4 操守信息：行业资质考核审计情况、纪律处分、指控投诉、信用记录等；</div>
              <div>1.5 争议信息：仲裁诉讼、强制执行等；</div>
              <div>1.6 第三方信息：法律允许情况下，从第三方或外部公开渠道获取的信息；</div>
              <div>1.7 利益冲突信息：基于岗位评估利益冲突所需要的信息；</div>
              <div>
                1.8
                上述信息中可能包含敏感信息，公司会采取严格保护措施。为使您在公司履行工作职责、提供服务或为了公司能够处理员工福利及公司运营管理所必需的事务，公司在有必要的情况下收集和使用您的个人信息。
              </div>
            </p>
            <p>
              <div>
                <span style={{ fontWeight: 'bold' }}>2. 您同意公司在以下情况处理您的个人信息</span>
              </div>
              <div>2.1 候选人识别和联系、对候选人进行背景调查和评估并做出录用决策、保留入职准备流程的相关记录；</div>
              <div>
                2.2
                公司基于工作管理、薪酬激励、考勤管理、审批休假、核发福利待遇、费用报销、绩效评估、违纪调查、突发事件、投诉处理、争议解决等需求；
              </div>
              <div>2.3 公司基于工作网络、系统、软件、设备、安全以及其他公司资产管理需求；</div>
              <div>
                2.4
                遵守、适用法律法规相关要求，满足所适用的税务、保险、健康、安全、劳动、就业、疫情防治等法律法规的规定；遵守适用的公司政策、程序和内部规章制度，进行内部调查；遵守公司财务和监管责任，包括审计要求(内部和外部)和成本/预算分析和控制等；
              </div>
              <div>
                2.5
                与公司员工和第三方(如现有或潜在的业务合作伙伴、供应商或政府)沟通，回应并遵守来自监管机构或其他权力机构的要求，处理涉及身份识别数据、联系方式、工作信息的信息；
              </div>
              <div>2.6 在涉及处理联系方式、个人信息、工作信息的紧急情况下，与您指定的联系人沟通；</div>
              <div>2.7 其他基于依据法律或授权的场景。</div>
            </p>

            <p>
              <div>
                <span style={{ fontWeight: 'bold' }}>3. 您同意公司在以下情况共享您的个人信息</span>
              </div>
              <div>
                3.1 在公司内，由于公司所属实体在多地设有关联公司及办事机构，
                <span style={{ fontWeight: 'bold' }}>
                  公司会根据人力资源管理所必需向公司内的其他实体共享您的个人信息，并会采取不低于本隐私政策的水平来保护您的个人信息安全；
                </span>
              </div>
              <div>
                <span style={{ fontWeight: 'bold' }}>
                  3.2
                  根据招聘，劳动合同订立、履行等需要，公司可以将您的联系方式提供给现有或潜在的业务合作伙伴、供应商或政府和其他第三方；
                </span>
              </div>
              <div>
                3.3
                根据适用法律的规定或者有权机关的要求，您信息可以提供给监管机构、法院、税务机关、相关执法机关等有权机关、独立外部顾问(如审计员、会计师、律师和顾问)、保险福利等供应商、内部合规和调查团队(包括被任命进行内部调查的外部顾问)等；
              </div>
              <div>
                3.4
                您工作的公司业务将全部或部分出售或转让(或正在考虑此类出售或转让)、重组、合并或破产等，您的信息数据将作为转让本身的一部分或作为此类转让的初步审查(即尽职调查)的一部分，转移给新雇主或潜在新雇主；
              </div>
              <div>3.5 其他合法合理需求或您提出或授权的场景。</div>
            </p>

            <p>
              <div>
                <span style={{ fontWeight: 'bold' }}>4. 公司会如何保护您的个人信息</span>
              </div>
              <div>
                4.1
                公司会努力采取合理的安全措施（包括技术方面和管理方面）来保护您的个人信息，特别是涉及敏感信息时，防止您提供的个人信息被不当使用或未经授权的情况下被访问、公开披露、使用、修改、损坏、丢失或泄漏；
              </div>
              <div>
                4.2
                公司建立专门的安全部门、安全管理制度、保密制度、数据安全流程，采取加密技术等措施，保障您的个人信息安全。我们采取严格的数据使用和访问制度，确保只有授权人员才可访问您的个人信息；
              </div>
              <div>
                4.3
                公司通过与信息接触者签署保密协议、监控和审计机制来对数据进行全面安全管理，防止您的信息遭到未经授权的访问、公开、披露、使用、修改、损坏或丢失；
              </div>
              <div>4.4 公司会举办信息安全和隐私保护培训课程，加强员工对于保护个人数据重要性的认识；</div>
              <div>
                4.5
                为防止安全事故的发生，公司制定了预警机制和应急预案。若不幸发生信息安全事件，公司会尽力采取处置措施、补救措施等，降低风险，力求将损失最小化；
              </div>
              <div>
                4.6
                我们将保留您的个人信息至实现处理目的所必要的最短时间。超出必要期限后，我们将对您的个人信息进行删除或匿名化处理，但法律法规另有规定的除外；
              </div>
              <div>
                4.7 您的个人信息将存储于
                <span style={{ fontWeight: 'bold' }}>境内</span>
                服务器，无论我们的服务器位于何处，我们都会根据本隐私政策采取适当措施，保护您的权利。我们不会将上述信息传输至境外，如果我们向境外传输，我们将会遵循相关国家规定或者征求您的同意；
              </div>
              <div>
                <span>4.8 尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，</span>
                但请您理解，没有任何安全措施能够保证百分之百完美或牢不可破。由于技术的限制以及可能存在的各种恶意手段，请您知悉并理解，在接入我们的服务所用的网站和通讯网络时，有可能因我们可控范围外的因素而出现问题，因此我们强烈建议您采取积极措施保护个人信息的安全；
              </div>
              <div>
                <span style={{ fontWeight: 'bold' }}>
                  4.9 若非美团原因导致您个人信息被不当使用的，风险需要您自行承担。您同意并认可美团在以下情况下免责：
                </span>
              </div>
              <div>
                （a）有关政府机关，包括但不限于税务机关、安全部门、警察、法院、检察院依照法定职权和法定程序要求美团披露您的个人信息；
              </div>
              <div>（b）由于您将用户密码告知他人或与他人共享注册帐户，由此导致的任何个人信息泄露；</div>
              <div>
                （c）任何由于计算机程序故障、黑客攻击、计算机病毒侵入或发作、因政府管制而造成的暂时性关闭等影响网络正常经营之不可抗力而造成的个人信息泄露、丢失、被盗用或被窜改等；
              </div>
              <div>（d）由于与本网站链接的其它网站所造成之个人信息泄露及由此而导致的任何法律争议和后果。</div>
            </p>

            <p>
              <div>
                <span style={{ fontWeight: 'bold' }}>5. 隐私政策修订、更新及通知</span>
              </div>
              <div>
                <span style={{ fontWeight: 'bold' }}>
                  如果本隐私政策有任何变更，我们将在此发布更新的隐私政策。请您定期访问本页面，查看本隐私政策是否有任何更新或变更。
                </span>
              </div>
            </p>

            <p>
              <div>
                <span style={{ fontWeight: 'bold' }}>6. 投诉举报及联系我们</span>
              </div>
              <div>
                如果您对个人信息保护问题有任何需求、疑问、建议、投诉，或对本隐私政策内容有任何疑问、意见或建议，您可以通过一下与我们联系，我们核查后会及时向您反馈。
              </div>
              <div>6.1 通过大象联系“员工帮助台之新人你好”；</div>
              <div>6.2 发送电子邮件到9000@meituan.com;</div>
              <div>6.3 通过电话联系您的招聘经理。</div>
            </p>
            <p>
              <div>
                <span style={{ fontWeight: 'bold' }}>7. 其他</span>
              </div>
              <div>7.1 本文所有条款的标题仅为阅读方便，不作为本文涵义解释或限制的依据；</div>
              <div>
                7.2 本文任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本函其余条款的有效性及可执行性；
              </div>
              <div>7.3 在法律允许的范围内，公司对本文拥有解释和修改的权利。</div>
            </p>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button type="primary" onClick={onClose}>
          关闭
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConformModal;
